import React from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ModalHeader from './Header';
import ModalBody from './Body';
import ModalFooter from './Footer';


const SelectionModal = function SelectionModal({
  content,
  formValues,
  programOptions,
  sectionOptions,
  updateFormValues,
  submitForm,
  modalIsOpen,
  closeModal,
  showDisclaimer,
}) {
  const { upperTitle, title } = content;
  const appElement = document.body.querySelector('.se-page');
  const modalProps = { ariaHideApp: !!appElement, appElement };
  const opcoNavBodyClass = classNames({
    'opco-nav-body__container': !content || !content.customFooter,
    'opco-nav-body__container opco-nav-body__container--with-footer': content && content.customFooter,
  });

  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      contentLabel="program selection modal"
      className="opco-navigator__modal"
      overlayClassName="opco-navigator__modal-overlay"
      {...modalProps}
    >
      <ModalHeader
        upperTitle={upperTitle}
        title={title}
        action={closeModal}
      />
      <div className={opcoNavBodyClass}>
        <ModalBody
          content={content}
          sectionOptions={sectionOptions}
          programOptions={programOptions}
          formValues={formValues}
          updateFormValues={updateFormValues}
          submitForm={submitForm}
          showDisclaimer={showDisclaimer}
        />
        {content.customFooter && (
          <ModalFooter {...content.customFooter} />
        )}
      </div>
    </Modal>

  );
};

SelectionModal.defaultProps = {
  sectionOptions: undefined,
  programOptions: [{}],
};

SelectionModal.propTypes = {
  content: PropTypes.shape({
    upperTitle: PropTypes.string,
    title: PropTypes.string,
    customFooter: PropTypes.shape({}),
  }).isRequired,
  formValues: PropTypes.shape({
    location: PropTypes.shape({}),
    locationType: PropTypes.string,
  }).isRequired,
  sectionOptions: PropTypes.arrayOf(PropTypes.shape({})),
  programOptions: PropTypes.arrayOf(PropTypes.shape({})),
  updateFormValues: PropTypes.func.isRequired,
  submitForm: PropTypes.func.isRequired,
  modalIsOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  showDisclaimer: PropTypes.bool.isRequired,
};

export default SelectionModal;
